import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"

import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableAvisAbsence from "./DataTableAvisAbsence"
import AddAvisAbsence from "./AddAvisAbsence"
import DataTableAvisAbsenceValidation from "./DataTableAvisAbsenceValidation"


const AvisAbsence = props => {
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }
  const renderBlock = section => {
    if (section === 3) {
      return <DataTableAvisAbsence />
    } else if (section === 2) {
      return <AddAvisAbsence setSection={setSection} back={back} />
    }else if(section === 1 ){
      return <DataTableAvisAbsenceValidation />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Avis d'absence")}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Avis d'absence")}
                </NavLink>
              </NavItem>

            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

AvisAbsence.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
}

export default withRouter(withTranslation()(AvisAbsence))
